<blaze-dialog
  (closeDialog)="onClose()"
  [contentClass]="'enable-notifications-dialog-content'"
  [contentHasPadding]="false"
  [scroll]="true"
  [showFooter]="false"
  [showHeader]="false"
  #blazeDialog
  class="enable-notifications-dialog"
  data-cy="EnableNotificationsDialog"
>
  <ng-container content>
    <div class="content">
      <mat-icon class="icon-32" svgIcon="icon_notification_32" />

      <h1 class="title">Stay in the loop</h1>

      <div class="message">
        You have notifications turned off. Enable them to get real-time updates on case alerts,
        policy limits, and status changes. You can change this setting later in your system
        preferences.
      </div>
    </div>

    <div class="actions">
      <button class="enable-btn" blazeButton="bat" (click)="onRequestNotificationPermission()">
        Set up permissions
      </button>
      <button class="not-now-btn" blazeButton="secondary" (click)="onDismissPermissionDialog()">
        Not Now
      </button>
    </div>
  </ng-container>
</blaze-dialog>
